import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';
import { ConfirmButtonGroup } from '#components/patterns/confirmations/confirm-button-group/ConfirmButtonGroup.tsx';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '#components/patterns/modal/index.ts';

type Props = {
  onClose: () => void;
  routesLimit: number;
};

export function TooManyRoutesModal({ onClose, routesLimit }: Props) {
  return (
    <Modal isOpen={true} onClose={onClose}>
      <ModalHeader>Account limit reached</ModalHeader>

      <ModalBody>
        <p className="p">
          You’ve reached the maximum limit of {routesLimit} routes. Please delete unused routes before adding more, or
          reach out to support to request additional routes.
        </p>
      </ModalBody>
      <ModalFooter>
        <ConfirmButtonGroup
          variant="right"
          primaryButton={
            <LinkButton variant="primary" to="/routes">
              Back to routes
            </LinkButton>
          }
          secondaryButton={
            <LinkButton variant="link" to="/support/contact">
              Contact us
            </LinkButton>
          }
        />
      </ModalFooter>
    </Modal>
  );
}
